import Lenis from 'lenis'
import { ScrollTrigger } from '../lib/gsap';

const initScroll = () => {
    // Initialize a new Lenis instance for smooth scrolling
    const lenis = new Lenis({
        duration: 1,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        anchors: {
            onComplete: () => {
                // Hide navbar on anchor scroll
                document.body.setAttribute('data-scroll-direction', 'down');

                window.menuActive = false;
                document.body.classList.remove('menu-open');
            }
        }
    });

    function raf(time) {
        lenis.raf(time);
        ScrollTrigger.update();
        requestAnimationFrame(raf);
    }
    
    requestAnimationFrame(raf);

    lenis.on('scroll', (event) => {
        const direction = event.direction;

        if(event.animatedScroll > 400) {
            if(direction === 1) {
                document.body.setAttribute('data-scroll-direction', 'down');
            } else {
                document.body.setAttribute('data-scroll-direction', 'up');
            }
        } else {
            document.body.setAttribute('data-scroll-direction', 'top');
        }
    });

    const logoLink = document.querySelector('.js-logo-link');

    logoLink.addEventListener('click', (event) => {
        event.preventDefault();
        lenis.scrollTo(0);
    })
}

export { initScroll as default };
